<template>
  <div class="app-main">
    <transition name="fade" mode="out-in">
      <router-view class="app-container" />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'default',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>

//fade transition
.fade-leave-active,
.fade-enter-active {
  transition: all .5s;
}
.fade-enter {
  opacity: 0;
  transform: translateX(-30px);
}
.fade-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

@import '@/assets/styles/view-style/page.scss';
</style>



// WEBPACK FOOTER //
// src/views/layout/AppMain.vue